import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  RootProvider,
  CallDashboardProvider,
  useCallDashboard,
} from 'roger-call-dashboard';

const AWS_CONNECT_URL_CCP = process.env.REACT_APP_CONNECT_URL_CCP!;
const AWS_CONNECT_URL = process.env.REACT_APP_CONNECT_URL!;
const REACT_APP_CALL_DASHBOARD_API = process.env.REACT_APP_CALL_DASHBOARD_API!;

interface ICallDashboardOptionsProps {
  children: React.ReactNode;
}

const CallDashboardOptions: React.FC<ICallDashboardOptionsProps> = ({
  children,
}) => {
  const { contact, isInitialized, init } = useCallDashboard();

  const {
    connect: { setConnectCanCall },
  } = useDispatch();

  useEffect(() => {
    if (!isInitialized) {
      init();
    }
  }, [isInitialized, init]);

  useEffect(() => {
    setConnectCanCall(!contact && isInitialized);
  }, [contact, isInitialized]);

  return children;
};

interface IProps {
  children?: React.ReactNode;
}

const CallDashboardLayout: React.FC<IProps> = ({ children }) => {
  return (
    <RootProvider apiUrl={REACT_APP_CALL_DASHBOARD_API}>
      <CallDashboardProvider
        containerId="aws-call-dashboard"
        loginUrl={AWS_CONNECT_URL}
        ccpUrl={AWS_CONNECT_URL_CCP}
        outpageShow={false}
      >
        <CallDashboardOptions>{children}</CallDashboardOptions>
      </CallDashboardProvider>
    </RootProvider>
  );
};

export default CallDashboardLayout;
